import { Component, OnInit } from '@angular/core';
import {LandingService} from '../landing.service'
import { trigger, state, style, transition, animate, stagger } from '@angular/animations';
import {Router, ActivatedRoute} from '@angular/router';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  animations: [
    trigger('bar', [
      // ...
      transition (':enter', [
        style({opacity: 0}),
        animate ('2s 0.5s ease',
          style ({ opacity: '1', }),
        ),
      ]),
    ]),
  ],
})
export class NavbarComponent implements OnInit {

  menuOpen = true;
  selectedmenu: string;

  constructor( public landingService: LandingService, private router: Router, private activeRoute: ActivatedRoute) { }

  ngOnInit() {
    this.landingService.currentPos.subscribe(pos => {
      console.log(pos)
      this.selectmenu(pos);
    })
  }

  selectmenu(menuitem){
    this.selectedmenu = menuitem;
  }

}
